import React from 'react';
import { XCircle } from 'lucide-react';
export const ProblemSection: React.FC = () => {
  const problems = ['Pasás horas cada semana buscando ejercicios nuevos en internet, videos de YouTube o apuntes viejos, y aún así terminás usando siempre las mismas progresiones', 'Te cuesta organizar las clases por nivel de dificultad y tus alumnos progresan de forma desigual, lo que genera frustración tanto en niños como en padres', 'Los padres te hacen preguntas constantemente sobre la evolución de sus hijos y no siempre sabés qué responder o cómo comunicarlo profesionalmente', 'No tenés un plan anual estructurado y vas improvisando clase a clase, lo que te genera estrés constante y sensación de desorganización'];
  return <section className="py-16 bg-red-50" data-id="element-262">
      <div className="max-w-5xl mx-auto px-4" data-id="element-263">
        <div className="text-center mb-12" data-id="element-264">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-265">
            ¿Te resulta familiar alguna de estas situaciones?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-266">
          {problems.map((problem, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-red-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-267">
              <div className="flex-shrink-0 mt-1" data-id="element-268">
                <XCircle className="w-8 h-8 text-red-500" data-id="element-269" />
              </div>
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-270">
                {problem}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};